import * as React from 'react';
import { AppBar, Toolbar, IconButton, Typography, Button } from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';

import { Logout } from '@mui/icons-material';
import firebaseConfig from '../../config/firebase';
import { getAuth, signOut } from 'firebase/auth';
// import AccountMenu from '../../components/AccountMenu';

function MyAppBar({ drawerWidth, handleDrawerToggle }) {
  return (
    <AppBar
      position='fixed'
      sx={{
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` },
      }}>
      <Toolbar>
        <IconButton
          color='inherit'
          aria-label='open drawer'
          edge='start'
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { sm: 'none' } }}>
          <MenuIcon />
        </IconButton>
        <Typography variant='h6' noWrap component='div' sx={{ flexGrow: 1 }}>
          Oliu - backoffice
        </Typography>
        <Button
          sx={{
            color: 'white',
          }}
          variant='text'
          startIcon={<Logout />}
          onClick={async () => {
            await signOut(getAuth(firebaseConfig));
            window.location.href = '/login';
          }}>
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
}

export default MyAppBar;
